module.exports = __webpack_public_path__ + "img/img4.1398d90d.svg";